import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  CreateUserRequest,
  CreateUserResponse,
  ForgotPasswordRequest,
  GetUserRequest,
  GetUserResponse,
  GetUsersRequest,
  GetUsersResponse,
  LogInRequest,
  RedeemResetTokenRequest,
  UpdateUserRequest,
  UpdateUserResponse,
  UserWithMeta,
  SignInWithGoogleRequest,
  UpdateProfileRequest,
} from 'src/common-services/types/user-types'
import { BaseClient } from 'src/common-services/clients/base-client'
import { ContactUsRequest } from 'src/common-services/types/base-types'

export class UserClient extends BaseClient {
  logIn(request: LogInRequest): Promise<UserWithMeta> {
    return this.call<UserWithMeta>('/users/login', 'POST', { data: request })
  }

  signInWithGoogle(request: SignInWithGoogleRequest): Promise<UserWithMeta> {
    return this.call<UserWithMeta>('/users/sign-in-with-google', 'POST', { data: request })
  }

  current(): Promise<UserWithMeta | undefined> {
    return this.call('/users/current', 'GET')
  }

  async loginElsewhere(): Promise<void> {
    await this.post('/system/login-elsewhere', {})
  }

  changePassword(request: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    return this.call<ChangePasswordResponse>('/users/change-password', 'POST', { data: request })
  }

  getUsers(request?: GetUsersRequest): Promise<GetUsersResponse> {
    return this.call<GetUsersResponse>('/users', 'GET', { params: request })
  }

  getUser(request: GetUserRequest): Promise<GetUserResponse> {
    return this.call<GetUserResponse>(`/users/${request.id}`, 'GET')
  }

  createUser(request: CreateUserRequest): Promise<CreateUserResponse> {
    return this.call<CreateUserResponse>('/users', 'POST', { data: request })
  }

  updateUser(request: UpdateUserRequest): Promise<UpdateUserResponse> {
    return this.call<UpdateUserResponse>(`/users/${request.id}`, 'PUT', { data: request })
  }

  forgotPassword(request: ForgotPasswordRequest): Promise<void> {
    return this.call('/users/reset-password', 'POST', { data: request })
  }

  redeemResetToken(token: string, request: RedeemResetTokenRequest): Promise<void> {
    return this.call(`/users/reset-password/${token}`, 'PUT', { data: request })
  }

  sendWelcomeEmail(email: string): Promise<void> {
    return this.call('/users/send-welcome-email', 'POST', { data: { email } })
  }

  contactUs(data: ContactUsRequest): Promise<void> {
    return this.call('/users/contact-us', 'POST', { data })
  }

  updateProfile(request: UpdateProfileRequest): Promise<void> {
    return this.call<void>('/users/profile', 'PUT', { data: request })
  }
}
